import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBuilding, faChartPie } from "@fortawesome/free-solid-svg-icons";

import { getCurrencyValue } from "../../../utils/general";

const COLORS = ["#38bdf8", "#f472b6", "#34d399", "#fbbf24", "#a78bfa", "#f87171", "#22d3ee"];

function Section({ title, icon, rows, max, formatValue }) {
  return (
    <div className="lt-panel">
      <div className="lt-panel-title">
        <span className="lt-panel-title-left">
          <FontAwesomeIcon icon={icon} />
          {title}
        </span>
        <span>{rows.length}</span>
      </div>
      {rows.length === 0 ? (
        <div className="lt-feed-empty">Aucune donnée pour aujourd'hui</div>
      ) : (
        rows.slice(0, 6).map((row, i) => {
          const pct = max ? (row.count * 100) / max : 0;
          return (
            <div key={row.name} className="lt-bar-row">
              <div className="lt-bar-row-label">
                <span
                  className="lt-bar-row-dot"
                  style={{ background: COLORS[i % COLORS.length], color: COLORS[i % COLORS.length] }}
                />
                {row.name}
              </div>
              <div className="lt-bar-row-value">
                {formatValue ? formatValue(row) : row.count}
              </div>
              <div className="lt-bar-track">
                <div
                  className="lt-bar-fill"
                  style={{
                    width: `${pct}%`,
                    background: `linear-gradient(90deg, ${COLORS[i % COLORS.length]}, rgba(244,114,182,0.8))`,
                    boxShadow: `0 0 10px ${COLORS[i % COLORS.length]}`,
                  }}
                />
              </div>
            </div>
          );
        })
      )}
    </div>
  );
}

// Rollups come from the API, computed over the full day. They must NOT be
// recomputed from `feed` here: the feed is a capped preview, so aggregating it
// would report on a sample of ~80 rows while the KPI cards above report the
// real totals — the two then disagree, and the panels move on every refresh.
export default function LiveBreakdown({ breakdown }) {
  const byCompany = breakdown?.honoraryByCompany || [];
  const byAgency = breakdown?.missionByCompany || [];
  const byAgencyClosing = breakdown?.closingByAgency || [];

  const fmtCA = (row) => getCurrencyValue(row.total || 0);

  return (
    <div className="lt-side-stack">
      <Section
        title="Facturation par compagnie"
        icon={faChartPie}
        rows={byCompany}
        max={byCompany[0]?.count || 0}
        formatValue={fmtCA}
      />
      <Section
        title="Missions reçues par compagnie"
        icon={faBuilding}
        rows={byAgency}
        max={byAgency[0]?.count || 0}
      />
      <Section
        title="Dépôts par agence"
        icon={faBuilding}
        rows={byAgencyClosing}
        max={byAgencyClosing[0]?.count || 0}
      />
    </div>
  );
}
